import type { MRT_Cell, MRT_Row, MRT_RowData } from '@brightdrop/table-ui';
import { Box } from '@mui/material';

import { DEFAULT_EMPTY_VALUE } from '~/common/constants/common.constant';
import type { ASSET_LIST_REPORT_MESSAGES } from '~/features/assets/report/AssetListReportView.messages';
import { formatLicensePlate } from '~/features/assets/utils/assets.utils';

type CellRendererProps<T extends MRT_RowData, TValue = string> = {
  cell: MRT_Cell<T, TValue>;
  row: MRT_Row<T>;
  valueLabels?: typeof ASSET_LIST_REPORT_MESSAGES.valueLabels;
  locale?: string;
};

export const LicensePlateCell = <T extends MRT_RowData>({
  cell,
}: CellRendererProps<T, string>): JSX.Element => {
  const licensePlate = cell.getValue();
  const displayValue = formatLicensePlate(licensePlate) || DEFAULT_EMPTY_VALUE;

  return (
    <Box component="span" data-testid="license-plate-cell">
      {displayValue}
    </Box>
  );
};
